/* eslint-disable import/prefer-default-export */
export const SET_CURRENT_SLIDE = "SET_CURRENT_SLIDE";
